import React from 'react';
import { useParams } from 'react-router-dom';

import { menuListTeknisiStaf, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";

import BarangKategoriIndex from "../../pagesSub/msBarangKategori/BarangKategoriIndex";
import BarangFormCekIndex from "../../pagesSub/msBarangFormCek/BarangFormCekIndex";

const MasterTS = () => {

    const { subMenu } = useParams();
    const menu = menuListTeknisiStaf.master.slug;
    const roleUser = role.teknisi;
    // const slugLink = roleUser.subLevel.teknisi_kepala.slugLink;

    return (
        <LayoutAppShell
            stateMenuList={menuListTeknisiStaf}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListTeknisiStaf.master.subMenu.brgKtgr.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListTeknisiStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <BarangKategoriIndex />
                </React.Fragment>
            }

            {menuListTeknisiStaf.master.subMenu.formCekBrg.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListTeknisiStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <BarangFormCekIndex />
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default MasterTS;